import { Star } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { AppStoreBadge } from "@/components/AppStoreBadge";
import { GooglePlayBadge } from "@/components/GooglePlayBadge";

export const DownloadCTA = () => (
  <section id="download" data-testid="download-section" className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
    <Reveal>
      <div className="relative overflow-hidden rounded-[20px] border-2 border-[#1A1D1E] bg-[#1FBCA2] px-8 py-16 text-center shadow-[0_10px_0_0_#1A1D1E] md:py-24">
        <Star
          aria-hidden="true"
          className="animate-slow-spin absolute -top-10 -left-10 h-40 w-40 fill-[#FFC837] text-[#FFC837] opacity-60"
        />
        <Star
          aria-hidden="true"
          className="animate-slow-spin absolute -bottom-12 -right-12 h-52 w-52 fill-[#FF7B72] text-[#FF7B72] opacity-50"
        />
        <div className="relative">
          <h2 className="font-display text-4xl font-bold tracking-tight text-[#1A1D1E] md:text-6xl">
            Ready for round one?
          </h2>
          <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-[#1A1D1E]/70 md:text-lg">
            Grab TriviaPro on the App Store and crown tonight's family trivia
            champion. Free to download – no ads, no sneaky in-app traps.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <AppStoreBadge testId="cta-app-store-badge" />
            <GooglePlayBadge testId="cta-google-play-badge" />
          </div>
          <p className="mt-6 text-xs font-extrabold uppercase tracking-[0.2em] text-[#1A1D1E]/50">
            iOS &amp; Android · Ages 6+ · No ads, ever
          </p>
        </div>
      </div>
    </Reveal>
  </section>
);
